// extracted by mini-css-extract-plugin
export default {"channelCell":"_KASN_6hjn9zLxe7JOeL","text":"uevu2EyLTwfIdLZ_ACJC","channelImage":"MsmW8KpMBoIZ8vKYkaBa","channelClickable":"HQt73PCdgjsP0yvKfrYB","horizontal":"Z6hHV0kWVCYxXRx6xxox"};